'use client'

import styled, { css } from 'styled-components'
import Input from 'antd/lib/input'

const { TextArea } = Input

export const InputWrapper = styled.div`
  margin-bottom: 1.8rem;
  position: relative;
`

export const LabelInfo = styled.span`
  ${({
    theme: {
      base: { grey },
    },
  }) => `
  margin-left: 0.8rem;  
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #C0C0C0;
`}
`

export const InputTextAreaWapper = styled(TextArea)`
  ${({
    theme: {
      base: { grey },
    },
  }) => css`
    resize: none;

    .ant-input {
      &:focus {
        box-shadow: unset;
        border: 1px solid ${grey[21]} !important;
      }
      &:hover {
        border: 1px solid ${grey[21]} !important;
      }
    }
  `}
`
